
export const CAMPAIGN_SLUG_MIN = 3;
export const CAMPAIGN_SLUG_MAX = 80;
export const CAMPAIGN_SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const SlugStatus = {
  EMPTY: "EMPTY",
  INVALID: "INVALID",
  CHECKING: "CHECKING",
  AVAILABLE: "AVAILABLE",
  TAKEN: "TAKEN",
  FAILED: "FAILED",
} as const;

export type SlugStatus = (typeof SlugStatus)[keyof typeof SlugStatus];

export const SLUG_CHECK_DEBOUNCE_MS = 400;
export const SLUG_SUFFIX_START = 2;
export const SLUG_SUFFIX_MAX = 9;

const CAMPAIGN_LINK_PATH = "/gameficacao/campanha";

export function isCampaignSlug(value: string): boolean {
  return (
    value.length >= CAMPAIGN_SLUG_MIN &&
    value.length <= CAMPAIGN_SLUG_MAX &&
    CAMPAIGN_SLUG_PATTERN.test(value)
  );
}

const WEB_PROTOCOLS: readonly string[] = ["http:", "https:"];

function portalBaseUrl(): string | null {
  const raw: string = (import.meta.env.VITE_GAMIFICATION_PORTAL_URL ?? "")
    .trim()
    .replace(/\/+$/, "");
  if (!URL.canParse(raw)) return null;
  return WEB_PROTOCOLS.includes(new URL(raw).protocol) ? raw : null;
}

export function campaignPublicUrl(slug: string | null | undefined): string | null {
  const base: string | null = portalBaseUrl();
  if (!slug || !base) return null;
  return `${base}${CAMPAIGN_LINK_PATH}/${slug}`;
}

export function withSlugSuffix(base: string, suffix: number): string {
  const tail: string = `-${suffix}`;
  return `${base.slice(0, CAMPAIGN_SLUG_MAX - tail.length).replace(/-+$/, "")}${tail}`;
}

export function localSlugStatus(slug: string | null | undefined): SlugStatus {
  const value: string = (slug ?? "").trim();
  if (!value) return SlugStatus.EMPTY;
  return isCampaignSlug(value) ? SlugStatus.AVAILABLE : SlugStatus.INVALID;
}
